module.exports = __webpack_public_path__ + "img/fmovies-alternatives.3ee41465.webp";